import { Button, Dropdown } from "antd";

const items = [
  {
    key: "1",
    label: <a> Editar </a>,
  },
  {
    key: "2",
    label: <a> Desativar </a>,
  },
];

const ColumnsAccountPlan = [
  {
    title: "Cliente",
    dataIndex: "name",
    textWrap: "word-break",
    ellipsis: true,
  },
  {
    title: "Data",
    dataIndex: "email",
    textWrap: "word-break",
    ellipsis: true,
  },

  {
    title: "Status",
    dataIndex: "active",
    render: (text) => {
      if (text) {
        return <div>{"Ativo"}</div>;
      } else {
        return <div>{"Desativado"}</div>;
      }
    },
  },
  {
    title: "Ações",
    dataIndex: "action",
    render: (text) => {
      return (
        <div>
          <Dropdown
            menu={{ items }}
            placement="bottom"
            arrow={{ pointAtCenter: true }}
          >
            <Button type="primary" className="button-action">
              Ações
            </Button>
          </Dropdown>
        </div>
      );
    },
  },
];

export default ColumnsAccountPlan;
